/** @deprecated Старая структура марафонов, будет заменена. Весь слайс подлежит удалению. */
import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { CourseState } from '../../types/course';

const initialState: CourseState = {
  isLoading: false,
  courseList: {},
  allCourses: [],
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.MARATHON },
};

const slice = createSlice({
  name: 'marathon',
  initialState,
  reducers: {
    marathonStartLoading(state) {
      state.isLoading = true;
    },

    getAllCoursesSuccess(state, action) {
      state.allCourses = action.payload;
    },

    marathonHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    marathonResetError(state) {
      state.error = undefined;
    },

    getMarathonListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getMarathonSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setMarathonListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearMarathon(state) {
      state.course = undefined;
    },

    clearMarathonList(state) {
      state.courseList = {};
    },

    clearMarathonParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  marathonStartLoading,
  marathonHasError,
  marathonResetError,
  getMarathonListSuccess,
  getMarathonSuccess,
  getAllCoursesSuccess,
  setMarathonListParams,
  clearMarathon,
  clearMarathonParameters,
  clearMarathonList,
} = slice.actions;
